import { Checkbox } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';

type Props = {
  dataItem: { visible: boolean };
};

export const VisibleSetting = observer(({ dataItem }: Props) => {
  return <Checkbox label='Visible' onChange={() => (dataItem.visible = !dataItem.visible)} checked={dataItem.visible} />;
});

export default VisibleSetting;
